import Vue from 'vue'
import Vuex from 'vuex'
// import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    state : {
        initData : {},
        productsData : {},
        cart : {
            coupons : [],
            items : [],
            sum : 0,
        },
    },
    mutations : {
        setCartItems (state, items = []) {
            state.cart.items = items;
        },
        setCartCoupons (state, coupons = []) {
            state.cart.coupons = coupons;
        },
        setCartTotalSum (state, sum = 0) {
            state.cart.sum = sum;
        },
        setInitData (state, data) {
            state.initData = data;
        },
        setProductsData (state, productsData) {
            for (var productId in productsData) {
                if (state.productsData[productId]) {
                    state.productsData[productId] = productsData[productId];
                }
                else {
                    Vue.set(state.productsData, productId, productsData[productId]);
                }
            }
        },
        setDelivery(state, delivery)
        {
            state.cart.delivery = delivery;
        }
    },
    actions : {
        loadInitData ({ commit }) {
            return new Promise(resolve => {
                fetch('/ajax/v1/init-data/')
                    .then(res => res.json())
                    .then(res => {
                        commit('setInitData', (res.data || {}));
                        if (res.cart) {
                            commit('setCartItems', res.cart.items || []);
                            commit('setCartCoupons', res.cart.coupons || []);
                            commit('setCartTotalSum', res.cart.sum);
                            commit('setDelivery', res.cart.delivery ? res.cart.delivery : false);
                        }
                        resolve(res);
                    });
            });
        },
        loadCartData ({ commit }) {
            return new Promise(resolve => {
                fetch('/ajax/v1/cart/')
                    .then(res => res.json())
                    .then(res => {
                        if (res) {
                            commit('setCartItems', res.items || []);
                            commit('setCartCoupons', res.coupons || []);
                            commit('setCartTotalSum', res.sum);
                            commit('setDelivery', res.delivery ? res.delivery : false);
                        }
                        resolve(res);
                    });
            });
        },
        loadProductData ({ commit }, data = {}) {
            return new Promise(resolve => {
                if (!this.productsLoadData) {
                    this.productsLoadData = [];
                }
                this.productsLoadData.push(data);
                clearTimeout(this.loadProductDataTimeout);
                this.loadProductDataTimeout = setTimeout(()=>{
                    let productIds = this.productsLoadData.map(o => o.productId).join(',');
                    fetch(`/ajax/v1/products/${productIds}/`)
                        .then(res => res.json())
                        .then(res => {
                            if (res.items) {
                                commit('setProductsData', res.items);
                                resolve(res);
                            }
                        });
                }, 1000);
            });
        },
    },
})
